import React from 'react';
import { MainProduct } from '@/components/organisms';
import { Section, WrapperExternal } from '@/components/atoms';
import createComponents, { IRest } from '@/utils/createComponents';
import useAbTest from '@/hooks/useAbTest';
import { useRouter } from 'next/router';
import { IProductPageTemplateCmp } from './IProductPageTemplateCmp';
import { isSection, isParagraph } from '@/utils/TypeGuards';
import { IImageWithTextBlockFields } from '@/types/contentful/contentful';

const ProductPageTemplate: React.FC<IProductPageTemplateCmp> = ({
  content,
  extraContent,
  productObj,
  shippingInfo,
  locale,
  availabilityInfos,
  pageType,
  brandSlug,
}) => {
  const router = useRouter();
  const appProps = useAbTest(content);

  let cont: (JSX.Element | null | undefined)[] = [];

  if (appProps) {
    cont = appProps.map((block, index: number) => {
      let rest: IRest = {};

      let marginBottom: string | undefined = block.fields.marginBottom;
      let withNoPaddingRight: boolean = false;

      if (isParagraph(block)) {
        marginBottom = block.fields.marginBottom;
        return (
          <Section
            key={index + block.sys.contentType.sys.id}
            marginBottom={marginBottom}
            visibility={block.fields?.visibility}
            visibilityForCustomerWithPreferences={
              block.fields?.visibilityForCustomerWithPreferences
            }
            visibilityForUsCustomer={block.fields?.visibilityForUsCustomer}>
            <WrapperExternal>
              {createComponents(block, { pageType, index })}
            </WrapperExternal>
          </Section>
        );
      }

      if (isSection(block)) {
        if (
          block.fields.organism?.sys.contentType.sys.id === 'productCarousel'
        ) {
          withNoPaddingRight = true;
          rest = {
            productType: productObj.productType,
            xselling_productpage: productObj.xsellingProductpage,
            id: block.fields.organism.sys.id + router.asPath,
          };
          if (
            extraContent &&
            extraContent.productCarousel &&
            extraContent.productCarousel.length > 0
          ) {
            extraContent.productCarousel.forEach(prd => {
              if (prd.id === block.fields?.organism?.sys?.id) {
                rest = {
                  ...rest,
                  products: prd.data,
                };
              }
            });
          }
        } else if (
          block.fields.organism?.sys?.contentType?.sys?.id === 'popupTimer'
        ) {
          rest = {
            index: index,
            bgcolor: block.fields.backgroundColor || null,
            visibility: block.fields.visibility || null,
          };
        } else if (
          block.fields.organism?.sys?.contentType?.sys?.id ===
          'imageWithTextBlock'
        ) {
          if (
            (block.fields.organism?.fields as IImageWithTextBlockFields)
              .template === 'carousel_custom_small' ||
            (block.fields.organism?.fields as IImageWithTextBlockFields)
              .template === 'carousel_custom'
          ) {
            withNoPaddingRight = true;
          }
        } else {
          rest = {
            index: index,
            bgcolor: block.fields.backgroundColor || null,
          };
        }
        return block ? (
          <Section
            key={index + (block.fields.organism?.sys.id || '')}
            marginBottom={marginBottom}
            heading={block.fields.heading}
            visibility={block.fields?.visibility}
            visibilityForUsCustomer={block.fields?.visibilityForUsCustomer}>
            <WrapperExternal withNoPaddingRight={withNoPaddingRight}>
              {createComponents(block.fields.organism, rest)}
            </WrapperExternal>
          </Section>
        ) : null;
      } else {
        //return block ? createComponents(block) : null;
      }
    });
  }

  return (
    <>
      {cont ? (
        <>
          <Section marginBottom="standard">
            <MainProduct
              productObj={productObj}
              shippingInfo={shippingInfo}
              availabilityInfos={availabilityInfos}
              locale={locale}
              brandSlug={brandSlug}
            />
          </Section>
          {cont}
        </>
      ) : null}
    </>
  );
};

export default ProductPageTemplate;
